import { defineMessages } from "react-intl";

export default defineMessages({
  defaultText: {
    id: "components.ErrorMessage.defaultText",
    defaultMessage: "No results found"
  }
});
